import { render } from "./LabeledToggle.vue?vue&type=template&id=37b64b2a&scoped=true"
import script from "./LabeledToggle.vue?vue&type=script&lang=js"
export * from "./LabeledToggle.vue?vue&type=script&lang=js"

import "./LabeledToggle.vue?vue&type=style&index=0&id=37b64b2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37b64b2a"

export default script